/**
 * Methods for registering/unregistering global keyboard shortcuts for a
 * ToDesktop application.
 *
 * @remarks
 * This package exposes a number of methods for registering/unregistering
 * global keyboard shortcuts for a ToDesktop application.
 *
 * **Note:** The shortcut is global; it will work even if the app does
 * not have the keyboard focus. This module cannot be used before the `ready`
 * event of the app module is emitted.
 *
 * @see {@link https://docs.todesktop.com}
 * @see {@link https://www.electronjs.org/docs/api/global-shortcut}
 * @experimental
 * @public
 * @packageDocumentation
 */
/**
 * Whether this application has registered `accelerator`.
 *
 * @param accelerator - Keyboard shortcut. See here: https://www.electronjs.org/docs/api/accelerator
 * @public
 */
export async function isRegistered(accelerator) {
    return window["todesktop"].shortcut.isRegistered(accelerator);
}
/**
 * Registers a global shortcut of `accelerator`.
 *
 * @param accelerator - Keyboard shortcut. See here: https://www.electronjs.org/docs/api/accelerator
 * @param handler - Called when the registered shortcut is pressed by the user
 * @public
 */
export async function register(accelerator, handler) {
    return window["todesktop"].shortcut.register(accelerator, handler);
}
/**
 * Unregisters a global shortcut of `accelerator`.
 *
 * @param accelerator - Keyboard shortcut. See here: https://www.electronjs.org/docs/api/accelerator
 * @public
 */
export async function unregister(accelerator) {
    return window["todesktop"].shortcut.unregister(accelerator);
}
/**
 * Unregisters all global shortcuts.
 *
 * @public
 */
export async function unregisterAll() {
    return window["todesktop"].shortcut.unregisterAll();
}
